<template>
  <div>
    <mg-dialog
      :show.sync="dialogVisible"
      title="系统提示"
      size="small"
      @cancel="cancel"
    >
      <div class="offline-dialog__content">
        <div class="tips">
          你的账号在其他地方登录，超出了同时登录设备的数量限制,此设备被强制下线，请重新登录，若非您本人的登录行为，请修改密码！
        </div>
        <div class="offline-btns">
          <el-button class="cancel-btn" type="primary" @click="cancel"
            >取消</el-button
          >
          <el-button class="confirm-btn" @click="reLogin">重新登录</el-button>
          <el-button
            class="confirm-btn"
            v-if="isAuthenticated"
            @click="modifyPwd"
            >修改密码</el-button
          >
        </div>
      </div>
    </mg-dialog>
    <UpdatePassword ref="updatePassword" @success="handleSuccess" />
  </div>
</template>

<script>
import MgDialog from "../mg-dialog/Index.vue";
import UpdatePassword from "../update-password/Index.vue";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      },
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  data() {
    return {
      dialogVisible: false,
      timer: null,
    };
  },
  methods: {
    handleSuccess() {
      let time = 5;
      this.$confirm(
        `修改成功，<span id='quit-timed' style='color: #2AB18A'>${time}</span>s秒后会退出登录~`,
        "",
        {
          center: true,
          customClass: "auto-message",
          showCancelButton: false,
          showConfirmButton: false,
          dangerouslyUseHTMLString: true,
        }
      );
      this.timer = setInterval(() => {
        time--;
        document.getElementById("quit-timed").innerHTML = time; //实现动态渲染
        if (time == 0) {
          clearInterval(this.timer); //如果到0清除倒计时
          this.$msgbox.close(false); //关闭弹窗
          this.$store.dispatch("clearProfile");
          this.cancel();
        }
      }, 1000);
    },
    cancel() {
      this.dialogVisible = false;
      this.close();
    },
    reLogin() {
      this.dialogVisible = false;
      this.close();
      this.$loginDialog();
    },
    modifyPwd() {
      this.$refs.updatePassword.showDialog();
    },
  },
  components: {
    MgDialog,
    UpdatePassword,
  },
};
</script>

<style scoped lang="scss">
.offline-dialog__content {
}
.offline-btns {
  text-align: center;
  margin-top: 35px;
  .cancel-btn {
    width: 78px;
    height: 36px;
    background: #f2f3f5;
    border-radius: 8px;
    border: none;
    font-weight: 400;
    font-size: 14px;
    color: #0d1400;
    padding: 0;
    &:hover {
      background: #f2f3f5 !important;
    }
  }
  .confirm-btn {
    width: 96px;
    height: 36px;
    padding: 0;
    line-height: 34px;
    border-color: #00e884;
    font-weight: 500;
    font-size: 14px;
    border-radius: 8px;
    color: #00c89d;
  }
}
</style>
